import { CommonTabbarContext } from "@/App";
import { updateGutterSection } from "@/api/building/gutter-section";
import { TAB_TYPE } from "@/commons/enums/tab-type";
import { CommonTabbarState } from "@/commons/components/common-tabbar";
import { GutterSection } from "@/commons/interface/building/gutter-section";
import { graphicStore } from "@/commons/store/graphic-store";
import { ARCHI_CTRL_TYPE } from "@/passets/archibase-engine/enums/archibase-control-type";
import { ARCHIBASE_SINGAL } from "@/passets/archibase-engine/enums/archibase-singal";
import classNames from "classnames";
import { AddPlineCommand, PlineT, Point } from "pytha";
import { useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Vector3 } from "three";
import TnMessage from "@/commons/widget/message";
import TnInput from "@/commons/widget/input/tn-input";
import { deletePrimitivesInGraphic } from "@/api/geometry/primitive";
interface Iprops {
    item: GutterSection
    onSaveName: (name: string) => void
    onSaveDraw: (entity: any) => void
}

export default function GutterEditItem(props: Iprops, ref) {
    const { projectUuid } = useParams();
    const { item } = props;
    const navigate = useNavigate();
    const location = useLocation();  // 路径
    const [editing, setEditing] = useState<boolean>(false); // 当前正在编辑天沟的名称
    const [editName, setEditName] = useState<string>(); // 当前正在编辑的天沟的名称
    const [drawing, setDrawing] = useState<boolean>(false); // 当前正在绘制天沟截面
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文
    const pline = useRef<PlineT>(); // 绘制的天沟截面
    // const addPlineCmd = useRef<AddPlineCommand>(); // 创建天沟截面图元的命令

    // 开始编辑天沟名称
    const handleEditName = () => {
        setEditing(true);
        setEditName(item?.name);
    }

    useEffect(() => {
        handleEditName();
    }, [item])

    useImperativeHandle(ref, () => ({
        handleEditName: handleEditName,
    }))

    useEffect(() => {
        if (!location.pathname.includes(`${TAB_TYPE.GUTTER}/${item?.uuid}`)) {
            // 路径中没有天沟，已经跳转到别的路由页面，并没有正在绘制天沟截面，drawing置为false
            setDrawing(false);
        }
    }, [location])

    // 输入框失焦，保存天沟名称
    const saveName = () => {
        if (editName == null || editName === "") {
            TnMessage.error("天沟名称不能为空");
            setEditName('');
            return;
        }
        let data = { name: editName };
        updateGutterSection(item.uuid, data).then(res => {
            props.onSaveName(editName);
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("编辑失败");
            }
        }).finally(() => {
            setEditing(false);
            setEditName('');
        })
    }

    // 开始绘制屋面板截面
    const onStartDraw = () => {
        TnMessage.info("请沿x轴方向绘制")
        // 打开绘制屋面板的标签页
        commonTabbarContext.navigate(`${TAB_TYPE.GUTTER}/${item?.uuid}`);
        setDrawing(true);
        // // 激活绘制屋面板截面的二级控制器
        // if (!graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl || graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl.id !== ARCHI_CTRL_TYPE.DRAW_SECTION) {
        //     // 旋转视图到上视图
        //     graphicStore.extraContext.getCurrentViewEditor()?.viewCube.prepareAnimationData("pabcd");
        //     graphicStore.extraContext.getCurrentViewEditor().viewCube.animating = true;
        //     graphicStore.extraContext.getCurrentViewEditor().cmdControl.activateSubCommandControl("DRAWSECTIONCONTROL");
        //     // 监听绘制屋面板结束的信号
        //     graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onDrawSectionFinish).add(onDrawGutterSectionFinish);
        // }
    }

    // 绘制天沟结束
    // const onDrawGutterSectionFinish = (entity: PlineT, cmd: AddPlineCommand) => {
    //     pline.current = entity;
    //     addPlineCmd.current = cmd;
    //     // 移除监听
    //     graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onDrawSectionFinish).remove(onDrawGutterSectionFinish);
    // }

    const checkPline = () => {
        let entities = graphicStore.extraContext.getCurrentViewEditor().entityDict
        for (let uuid in entities) {
            let entity = entities[uuid]
            if (entity.baseType == "PlineT") {
                pline.current = entity as PlineT
                return true
            }
        }
        return false
    }

    // 保存天沟截面
    const saveDraw = () => {
        if (!checkPline()) {
            TnMessage.warning("请完成绘制天沟截面");
            setDrawing(false);
            return;
        }
        let plineEntity = pline.current;
        // 转至世界坐标系的原点处，存储截面世界坐标系下的几何信息
        // 基点，pline的起点
        let basePoint = new Vector3();
        let firstLine = plineEntity._geoCurves[0]
        if (firstLine) {
            basePoint.copy(firstLine.getPointAt(0))
        }
        // 计算以基点为坐标原点，当前坐标系下，图元的几何信息
        let normal = graphicStore.extraContext.getCurrentViewEditor().context.ucsContext.currentUcs.axisZ;
        let axisX = graphicStore.extraContext.getCurrentViewEditor().context.ucsContext.currentUcs.axisX;
        let moveDir = basePoint.clone().negate();
        let plineEntityClone = plineEntity.clone();
        plineEntityClone.move(moveDir.clone().normalize(), moveDir.length());
        let origin = new Point(0, 0, 0);
        let worldX = new Vector3(1, 0, 0);
        let worldZ = new Vector3(0, 0, 1);
        let normalRotateAxis = normal.clone().cross(worldZ).normalize();
        if (Math.abs(normal.dot(worldZ) + 1) < 1e-6) {
            normalRotateAxis = axisX.clone();
        }
        let normalDeltaAngle = worldZ.angleTo(normal);
        plineEntityClone.rotate(origin, normalRotateAxis, normalDeltaAngle);
        let tempAxisX = axisX.clone().applyAxisAngle(normalRotateAxis, normalDeltaAngle);
        let axisXRotateAxis = tempAxisX.clone().cross(worldX).normalize();
        let axisXDeltaAngle = tempAxisX.angleTo(worldX);
        if (Math.abs(tempAxisX.dot(worldX) + 1) < 1e-6) {
            axisXRotateAxis = worldZ.clone();
        }
        plineEntityClone.rotate(origin, axisXRotateAxis, axisXDeltaAngle);

        let data = { entity: plineEntityClone.toJson() };
        updateGutterSection(item.uuid, data).then(res => {
            // 删除绘制的屋面板截面图元
            deletePrimitivesInGraphic([plineEntity.uuid], projectUuid).then(res => {
                graphicStore.extraContext.getCurrentViewEditor().removeObject(plineEntity)
            }).then(res => {
                // 关闭页签
                graphicStore.extraContext.getCurrentViewEditor().listeners.signals.needRender.dispatch('redraw');
                onCloseTab(`${TAB_TYPE.GUTTER}/${item?.uuid}`, true);
                props.onSaveDraw(data.entity);
            })
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("编辑失败");
            }
        }).finally(() => {
            setDrawing(false);
        })
    }

    // 关闭页签
    const onCloseTab = (url, active) => {
        let idx = commonTabbarContext.routes.findIndex(item => item.url === url);
        let res = commonTabbarContext.routes.filter(item => item.url != url) || [];
        commonTabbarContext.setRoutesOverwrite(res);
        if (!active) return;
        if (res.length <= 0) return;
        if (idx >= res.length) idx = res.length - 1;
        if (idx < 0) idx = 0;

        if (!!commonTabbarContext.navigate) {
            commonTabbarContext.navigate(res[idx].url);
        } else {
            navigate(-1);
        }
    }


    return (
        <div className="gutter-item">
            <div className={classNames({
                "name": true,
                "edit": true,
            })}>
                {editing &&
                    <TnInput
                        placeholder="输入天沟名称"
                        value={editName}
                        onTextChange={(value) => setEditName(value)}
                        onBlur={() => saveName()}
                        autoFocus
                    />
                }
                {!editing && <div className="text">{item?.name}</div>}
            </div>
            {!drawing && <div className="draw-btn" onClick={onStartDraw}>绘制天沟截面</div>}
            {drawing && <div className="draw-btn" onClick={saveDraw}>保存天沟截面</div>}
        </div>
    )
}